import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import HStack from './HStack'
import VStack from './VStack'
import RStack from './RStack'
import Data from './data/Data'

import { ReactComponent as MobileIcon } from './images/mobile-screen-solid.svg'
import { ReactComponent as EmailIcon } from './images/mail.svg'
import { ReactComponent as LocationIcon } from './images/location_on.svg'
import office from './images/office.jpg'
import office_small from './images/office_small.webp'
import office_medium from './images/office_medium.webp'
import office_large from './images/office_large.webp'

const theme = Data.theme

const componentStyles = {
    small: {
        container: {
            root: {
                justifyContent: 'space-around',
            }
        },
        textContainer: {
            root: {
                heightt: '100%',
                margin: 20,
                color: 'white',
                background: theme.colours.primary,
                borderRadius: 10,
                width: '90%',
                alignSelf: 'center', padding: 10
            }
        },
        mapContainer: {
            root: {
                alignItems: 'center',
                margin: 20,
                height: 280,
                border: 'solid 1px #ddd',
                borderRadius: 10,
            }
        },
        imageContainer: {
            root: {
                margin: '0 20px',
                height: '100%',
                border: 'solid 1px #ddd',
                borderRadius: 10,
            }
        },
        text: { root: { fontSize: 20, fontWeight: 600, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        textLink: { root: { fontSize: 12, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    },
    medium: {
        container: {
            root: {
            }
        },
        topContainer: {
            root: {
                alignItems: 'center', 
                background: theme.colours.primary, 
                borderRadius: 10, 
                margin: '10px 20px', 
                padding: 10
            }
        },
        bottomContainer: {
            root: {
                //justifyContent: 'center',
                margin: '20px 0',
                height: 350
            }
        },
        textContainer: {
            root: {
                height: '100%',
                margin: '0 20px',
                flexBasis: '50%',
                color: 'white',
                background: theme.colours.primary,
                borderRadius: 10,
                padding: 10,
                //justifyContent: 'space-around',
            }
        },
        mapContainer: {
            root: {
                flexBasis: '50%',
                margin: 20,
                margin: '0 20px',
                border: 'solid 1px #ddd',
                borderRadius: 10,
            }
        },
        imageContainer: {
            root: {
                flexBasis: '50%',
                margin: '0 20px',
                height: '100%',
                border: 'solid 1px #ddd',
                borderRadius: 10,
            }
        },
        text: { root: { fontSize: 20, fontWeight: 600, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        textLink: { root: { fontSize: 12, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    },
    large: {
        container: {
            root: {
                maxWidth: 1200,
                margin: '0 auto'
            }
        },
        topContainer: {
            root: {
                alignItems: 'center', 
                background: theme.colours.primary, 
                borderRadius: 10, 
                margin: '10px 20px', 
                padding: 10
            }
        },
        bottomContainer: {
            root: {
                //justifyContent: 'center',
                margin: '20px 0',
                height: 350,
            }
        },
        textContainer: {
            root: {
                height: '100%',
                margin: '0 20px',
                flexBasis: '50%',
                color: 'white',
                background: theme.colours.primary,
                borderRadius: 10,
                padding: 10,
                //justifyContent: 'space-around',
                //alignItems: 'center'
            }
        },
        mapContainer: {
            root: {
                alignItems: 'center',
                flexBasis: '50%',
                margin: '0 20px',
                border: 'solid 1px #ddd',
                borderRadius: 10,
            }
        },
        imageContainer: {
            root: {
                alignItems: 'center',
                flexBasis: '50%',
                margin: '0 20px',
                border: 'solid 1px #ddd',
                borderRadius: 10,
            }
        },
        text: { root: { fontSize: 20, fontWeight: 600, lineHeight: '150%', color: theme.colours.text, paddingBottom: 5 } },
        textLink: { root: { fontSize: 12, lineHeight: '150%', color: theme.colours.text, paddingBottom: 20 } },
    }
}

export default function Appointments(props) {
    const {
        size = 'large',
        appointmentRef,
    } = props

   


    const cStyles = componentStyles[size] ?? {}
    const office = size === 'small' ? office_small : size === 'large' ? office_large : office_medium

    

    if (size === 'small') {
        return (
            <>
                {/* <VStack styles={{ root: { padding: 0, fontSize: 36, fontWeight: 500, alignSelf: 'center', color: theme.colours.text } }}>
                Appointments
            </VStack>
            <VStack styles={{ root: { padding: '10px 0 40px', fontSize: 14, alignSelf: 'center', color: theme.colours.text } }}>
            For more information or to book an appointment call or email us.
            </VStack> */}
                <RStack stackRef={appointmentRef} size={size} styles={cStyles.container}>
                    <VStack grow={1} styles={cStyles.textContainer}>
                        <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                            <MobileIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                            <a href="tel:+27748262190" style={{ textDecoration: 'none' }}
                                target="_top">
                                <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2, width: 130 } }}>
                                    &nbsp;074 826 2190
                                </VStack>
                            </a>
                            <span>Dr Z Hu</span>
                        </HStack>
                        <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                            <MobileIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                            <a href="tel:+27631698802" style={{ textDecoration: 'none' }}
                                target="_top">
                                <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2, width: 130 } }}>
                                    &nbsp;063 169 8802
                                </VStack>
                            </a>
                            <span>Dr D Carpenter</span>
                        </HStack>
                        <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                            <MobileIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                            <a href="tel:+27846042944" style={{ textDecoration: 'none' }}
                                target="_top">
                                <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2, width: 130 } }}>
                                    &nbsp;084 604 2944
                                </VStack>
                            </a>
                            <span>Ms P Mbatha</span>
                        </HStack>
                        <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                            <EmailIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                            <a href="mailto:info@accma.co.za" style={{ textDecoration: 'none' }}
                                target="_top">
                                <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2 } }}>
                                    &nbsp;info@accma.co.za
                                </VStack>
                            </a>
                        </HStack>
                        <HStack styles={{ root: { alignItems: 'start', margin: '5px 0' } }}>
                            <LocationIcon style={{ width: 20, height: 20, fill: 'white', margin: '7px 15px' }} />
                            <VStack styles={{ root: { margin: '5px 0', cursor: 'pointer', lineHeight: '150%' } }}>
                                <VStack>Unit 31, Sunninghill Office Park</VStack>
                                <VStack>20 Peltier Drive, Sunninghill</VStack>
                                <VStack>Sandton, 2157</VStack>
                                <a href="https://g.page/AcupunctureGreenside?share" target="_blank"
                                    style={{ textDecoration: 'none', marginTop: 10 }}
                                >
                                    <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2 } }}>Get directions</VStack>
                                </a>
                            </VStack>
                        </HStack>

                        {/* <VStack styles={{root:{height: 300, width:250}}}>
                        <img src={office} alt='office' style={{ objectFit: 'cover', background: 'white', opacity: '0.9', borderRadius: '10px 10px 0 0', width: '100%' }} />
                    </VStack> */}
                    </VStack>
                    <VStack styles={cStyles.mapContainer}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d114720.36550328521!2d27.932613043359375!3d-26.033182299999975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e95735b294948b3%3A0x692d06236d9b1b0c!2sAfrican%20Centre%20of%20Chinese%20Medicine%20and%20Acupuncture!5e0!3m2!1sen!2sza!4v1698866412510!5m2!1sen!2sza"
                            //width={size === 'small' ? '100%' : '100%'} height="100%" 
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 0, borderRadius: 10,
                                //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' 
                            }} allow='' allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer">
                        </iframe>
                    </VStack>
                    <VStack styles={cStyles.imageContainer}>
                        <img src={office} alt='office' style={{ objectFit: 'cover', background: 'white', opacity: '0.9', borderRadius: 10, width: '100%' }} />
                    </VStack>
                </RStack>
            </>
        )
    }
    return (
        <VStack stackRef={appointmentRef} styles={cStyles.container}>
            {/* <VStack styles={{ root: { padding: 0, fontSize: 36, fontWeight: 500, alignSelf: 'center', color: theme.colours.text } }}>
                Appointments
            </VStack>
            <VStack styles={{ root: { padding: '10px 0 40px', fontSize: 14, alignSelf: 'center', color: theme.colours.text } }}>
            For more information or to book an appointment call or email us.
            </VStack> */}
            <HStack styles={cStyles.topContainer}>
                <VStack grow={1} styles={cStyles.textContainer}>
                    <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                        <MobileIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                        <a href="tel:+27748262190" style={{ textDecoration: 'none' }}
                            target="_top">
                            <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2, width: 130 } }}>
                                &nbsp;074 826 2190
                            </VStack>
                        </a>
                        <span>Dr Z Hu</span>
                    </HStack>
                    <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                        <MobileIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                        <a href="tel:+27631698802" style={{ textDecoration: 'none' }}
                            target="_top">
                            <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2, width: 130 } }}>
                                &nbsp;063 169 8802
                            </VStack>
                        </a>
                        <span>Dr D Carpenter</span>
                    </HStack>
                    <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                        <MobileIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                        <a href="tel:+27846042944" style={{ textDecoration: 'none' }}
                            target="_top">
                            <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2, width: 130 } }}>
                                &nbsp;084 604 2944
                            </VStack>
                        </a>
                        <span>Ms P Mbatha</span>
                    </HStack>
                    <HStack styles={{ root: { alignItems: 'center', margin: '5px 0' } }}>
                        <EmailIcon style={{ width: 20, height: 20, fill: 'white', margin: '5px 15px' }} />
                        <a href="mailto:info@accma.co.za" style={{ textDecoration: 'none' }}
                            target="_top">
                            <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2 } }}>
                                &nbsp;info@accma.co.za
                            </VStack>
                        </a>
                    </HStack>
                </VStack>
                <VStack grow={1} styles={cStyles.textContainer}>
                    <HStack styles={{ root: { alignItems: 'start', margin: '5px 0' } }}>
                        <LocationIcon style={{ width: 20, height: 20, fill: 'white', margin: '7px 15px' }} />
                        <VStack styles={{ root: { margin: '5px 0', cursor: 'pointer', lineHeight: '150%' } }}>
                            <VStack>Unit 31, Sunninghill Office Park</VStack>
                            <VStack>20 Peltier Drive, Sunninghill</VStack>
                            <VStack>Sandton, 2157</VStack>
                            <a href="https://g.page/AcupunctureGreenside?share" target="_blank"
                                style={{ textDecoration: 'none', marginTop: 10 }}
                            >
                                <VStack styles={{ root: { textDecoration: 'underline', color: theme.colours.primaryAlt2 } }}>Get directions</VStack>
                            </a>
                        </VStack>
                    </HStack>

                    {/* <VStack styles={{root:{height: 300, width:250}}}>
                        <img src={office} alt='office' style={{ objectFit: 'cover', background: 'white', opacity: '0.9', borderRadius: '10px 10px 0 0', width: '100%' }} />
                    </VStack> */}
                </VStack>
            </HStack>
            <RStack size={size} styles={cStyles.bottomContainer}>
                <VStack styles={cStyles.mapContainer}>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d114720.36550328521!2d27.932613043359375!3d-26.033182299999975!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e95735b294948b3%3A0x692d06236d9b1b0c!2sAfrican%20Centre%20of%20Chinese%20Medicine%20and%20Acupuncture!5e0!3m2!1sen!2sza!4v1698866412510!5m2!1sen!2sza"
                        //width={size === 'small' ? '100%' : '100%'} height="100%" 
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 0, borderRadius: 10,
                            //boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' 
                        }} allow='' allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer">
                    </iframe>
                </VStack>
                <VStack styles={cStyles.imageContainer}>
                    <img src={office} alt='office' style={{ objectFit: 'cover', background: 'white', opacity: '1', 
                    borderRadius: 10, height: '100%', width: '100%'}} />
                </VStack>
            </RStack>
            </VStack>
    )
    
}